import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { LIVE_MUSIC, SERVICE, BAND, MUSICIAN } from "../../../../consts";

// Actions
import {
    openBannerModal,
    closeBannerModal,
    saveBanner,
    saveBannerSettings,
    saveMobileBanner
} from '../../../../Actions/admin';
import { getDatatypes } from '../../../../Actions/main';

import '../mainAdminstyles.css';

// components
import { BannerCards } from '../AdminComponents/BannerCards';

import './styles.css';
import { ButtonSimple } from "../../../Elements/Buttons";
import {getQueryParamFromUrl} from "../../../../utils";

class Banner extends Component {
    constructor(props) {
        super(props);

        this.state = {
            videoLiveMusic: '',
            videoService: '',
            videoBand: '',
            videoMusician: '',
            videoUserPanel: ''
        };
    }

    componentWillMount() {
        this.props.getDatatypes();
    }

    componentWillReceiveProps(nextProp) {
        if (!nextProp.datatypes || !nextProp.datatypes.banner) return;

        this.setState({
            videoLiveMusic: nextProp.datatypes.banner.video[LIVE_MUSIC],
            videoService: nextProp.datatypes.banner.video[SERVICE],
            videoBand: nextProp.datatypes.banner.video[BAND],
            videoMusician: nextProp.datatypes.banner.video[MUSICIAN],
            videoUserPanel: nextProp.datatypes.banner.video.userPanel,
        })
    }

    openEditModal(type, bannerIndex) {
        this.props.openBannerModal(type, bannerIndex);
    }

    deleteBanner(event, bannerIndex, bannerType) {
        event.stopPropagation();
        if (!window.confirm('Are you sure you want to remove this banner')) return;

        const dataTypes = JSON.parse(JSON.stringify(this.props.datatypes));

        if (!dataTypes.banner[bannerType][bannerIndex]) return;

        dataTypes.banner[bannerType].splice(bannerIndex, 1);

        this.props.saveBanner(dataTypes)
            .then(() => {
                this.props.getDatatypes();
            })
    }

    onChangeHandler(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    saveHandler(videoUrl, type) {
        if (!window.confirm('Are you sure you want to save those changes?')) return;

        // convert from YT link: https://www.youtube.com/embed/-sNWKbnaFkg
        // into embed format: https://www.youtube.com/watch?v=-sNWKbnaFkg&ab_channel=AxelThesleff

        if (!videoUrl) return this.props.saveBannerSettings(this.props.token, { videoUrl, type });

        if (videoUrl.includes('youtube')) {
            const ytVideoID = getQueryParamFromUrl(videoUrl, 'v');

            if (ytVideoID) {
                videoUrl = `https://www.youtube.com/embed/${ytVideoID}`;
            }
        }

        this.props.saveBannerSettings(this.props.token, { videoUrl, type })
    }

    handleSaveBanner(banners, platform) {
        if (!banners || banners.length < 1 || !platform) return;

        if (!window.confirm('Are you sure you want to save those banners?')) return;

        this.props.saveBanner(this.props.datatypes, banners, platform);
    }

    handleShowHide(pinType, isVisible, platform = 'mobile') {
        if (!pinType || !platform || !this.props.datatypes.banner) return;


        const newSettings = { ...this.props.datatypes.banner[platform] || {}, [pinType]: isVisible }
        this.props.saveMobileBanner(newSettings, platform)
    }

    render() {
        return (
            <div className="admin-wrapper banner-selector-wrapper">
                <div className="content">
                    <div className="top-bar">
                        <div className="title">Main Page Banner</div>
                    </div>
                    <div style={{height: '40px'}} />

                    <BannerCards
                        header="Mobile Banners"
                        platform="mobile"
                        shownBanners={(this.props.datatypes && this.props.datatypes.banner && this.props.datatypes.banner.mobile) || {}}
                        handleSave={banners => this.handleSaveBanner(banners, 'mobile')}
                        handleShowHide={(pinType, isVisible) => this.handleShowHide(pinType, isVisible, 'mobile')}
                    />

                    <BannerCards
                        header="Web Banners"
                        platform="web"
                        shownBanners={(this.props.datatypes && this.props.datatypes.banner && this.props.datatypes.banner.web) || {}}
                        handleSave={banners => this.handleSaveBanner(banners, 'web')}
                        handleShowHide={(pinType, isVisible) => this.handleShowHide(pinType, isVisible, 'web')}
                    />

                    <div className="video-links-wrapper">
                        <div className="categories-cards-header">Video Links</div>
                        <div className="input-wrapper">
                            <label>Video Link - Live Music:</label>
                            <input
                                className="video-input"
                                onChange={(event) => this.onChangeHandler(event)}
                                name="videoLiveMusic"
                                type="text"
                                value={this.state.videoLiveMusic || ''}
                            />
                            <ButtonSimple onPress={() => this.saveHandler(this.state.videoLiveMusic, LIVE_MUSIC)} label="Save" />

                        </div>
                        <div className="input-wrapper">
                            <label>Video Link - Service:</label>
                            <input
                                className="video-input"
                                onChange={(event) => this.onChangeHandler(event)}
                                name="videoService"
                                type="text"
                                value={this.state.videoService || ''}
                            />
                            <ButtonSimple onPress={() => this.saveHandler(this.state.videoService, SERVICE)} label="Save" />

                        </div>
                        <div className="input-wrapper">
                            <label>Video Link - Band:</label>
                            <input
                                className="video-input"
                                onChange={(event) => this.onChangeHandler(event)}
                                name="videoBand"
                                type="text"
                                value={this.state.videoBand || ''}
                            />
                            <ButtonSimple onPress={() => this.saveHandler(this.state.videoBand, BAND)} label="Save" />

                        </div>
                        <div className="input-wrapper">
                            <label>Video Link - Musician:</label>
                            <input
                                className="video-input"
                                onChange={(event) => this.onChangeHandler(event)}
                                name="videoMusician"
                                type="text"
                                value={this.state.videoMusician || ''}
                            />
                            <ButtonSimple onPress={() => this.saveHandler(this.state.videoMusician, MUSICIAN)} label="Save" />

                        </div>

                        <div className="input-wrapper">
                            <label>Video Link - Use Panel:</label>
                            <input
                                className="video-input"
                                onChange={(event) => this.onChangeHandler(event)}
                                name="videoUserPanel"
                                type="text"
                                value={this.state.videoUserPanel || ''}
                            />
                            <ButtonSimple onPress={() => this.saveHandler(this.state.videoUserPanel, 'userPanel')} label="Save" />

                        </div>


                    </div>
                    <div style={{height: '40px'}} />
                    {/*<BannerCards*/}
                    {/*    header="User Panel Banner"*/}
                    {/*    type={BANNER_USER_PANEL}*/}
                    {/*    openNew={(type) => this.props.openBannerModal(type)}*/}
                    {/*    openEdit={(type, i) => this.openEditModal(type, i)}*/}
                    {/*    deleteBanner={(e, i, type) => this.deleteBanner(e, i, type)}*/}
                    {/*    banner={this.props.datatypes && this.props.datatypes.banner}*/}
                    {/*/>*/}
                </div>
                {/*<BannerModal*/}
                {/*    token={this.props.token}*/}
                {/*    isOpen={this.props.isBannerModalOpen}*/}
                {/*    bannerIndex={this.props.bannerIndex}*/}
                {/*    bannerType={this.props.bannerType}*/}
                {/*    closeModal={this.props.closeBannerModal}*/}
                {/*    datatypes={this.props.datatypes}*/}
                {/*    saveBanner={this.props.saveBanner}*/}
                {/*    getDatatypes={this.props.getDatatypes}*/}
                {/*/>*/}
            </div>
        )
    }
}

Banner.propTypes = {
    token: PropTypes.string,
    isBannerModalOpen: PropTypes.bool,
    openBannerModal: PropTypes.func,
    closeBannerModal: PropTypes.func,
    datatypes: PropTypes.object,
    getDatatypes: PropTypes.func,
    saveBanner: PropTypes.func,
    saveBannerSettings: PropTypes.func,
    saveMobileBanner: PropTypes.func,
    bannerIndex: PropTypes.number,
    bannerType: PropTypes.string
};

const mapStateToProps = (state) => ({
    token: state.users.token,
    isBannerModalOpen: state.admin && state.admin.isBannerModalOpen,
    datatypes: state.main.datatypes || {},
    bannerIndex: state.admin && state.admin.bannerIndex,
    bannerType: state.admin && state.admin.bannerType
});

export default connect(mapStateToProps, {
    openBannerModal,
    closeBannerModal,
    getDatatypes,
    saveBanner,
    saveBannerSettings,
    saveMobileBanner
})(Banner);



// WEBPACK FOOTER //
// ./src/Components/Screens/Admin/Banner/Banner.js